import type { ReactNode } from 'react'

interface SubTableWrapperProps {
  dark: boolean
  colSpan: number
  children: ReactNode
}

/**
 * Consistent wrapper for expanded sub-rows.
 * Renders <tr><td colSpan={n}> with a soft secondary background.
 * Children control their own interior padding and content.
 */
export function SubTableWrapper({ dark, colSpan, children }: SubTableWrapperProps) {
  return (
    <tr>
      <td
        colSpan={colSpan}
        className={`border-t ${
          dark
            ? 'bg-slate-900/55 border-white/4'
            : 'bg-slate-50/70 border-slate-100'
        }`}
      >
        {children}
      </td>
    </tr>
  )
}
